export const DELETE_PARTICIPANT_DIALOG = 'deleteParticipantDialog';
export const NOTIFICATION_SENT_DIALOG = 'notificationSentDialog';
export const REVERT_MATCH_DIALOG = 'revertMatchDialog';
